<template>
  <div>
    <step-indicator v-if="!creditInquiryAgreement" :step="indicatorStep" />
    <step01
      v-if="currentStep === 1"
      ref="step01"
      :estimate-price="estimatePrice"
      :insurance-price-types="options.insurancePriceTypes"
      :repairing-services="options.repairingServices"
      :data="application"
      @next="beforeMove(2, $event)"
      @change="changeBasicInfo"
    />
    <step02
      v-if="currentStep === 2"
      :is-short-term="isShortTerm"
      :is-monthly-subscribe="isMonthlySubscribe"
      :is-prepaid-payment="isPrepaidPayment"
      :is-avante-n="isAvanteN"
      :data="application"
      @next="beforeMove(3, $event)"
    />
    <agreement
      v-if="currentStep === 3"
      :data="application"
      :credit-inquiry-agreement="creditInquiryAgreement"
      :application-id="applicationId"
      @next="beforeMove(4, $event)"
      @back="back(2)"
      @save="save($event)"
    />
    <step03
      v-if="currentStep === 4 && application.warranty"
      :warranty-types="options.warrantyTypes"
      :warranty-percent="application.warranty.percent"
      :warranty-deposit="application.warranty.deposit"
      :data="application"
      @back="back(isShortTerm ? 2 : 3)"
      @next="beforeMove(5, $event)"
    />
    <step04
      v-if="currentStep === 5"
      :car-consignment-methods="options.carConsignmentMethods"
      :take-over-location-types="options.takeOverLocationTypes"
      :available-times="options.availableTimes"
      :funnels="options.funnels"
      :purposes="options.purposes"
      :data="application"
      :available-regions="availableRegions"
      @back="back(isWarrantyTarget ? 4 : isShortTerm ? 2 : 3)"
      @next="beforeMove(6, $event)"
      @changeAddress="changeAddress"
      @change="changeBasicInfo"
    />
    <step05
      v-if="currentStep === 6"
      :estimate-price="finalEstimatePrice"
      :insurance-price-types="options.insurancePriceTypes"
      :user-all-cards="options.userAllCards"
      :user-recurring-cards="options.userRecurringCards"
      :data="application"
      :is-monthly-subscribe="isMonthlySubscribe"
      @back="back(5)"
      @next="beforeMove(7, $event)"
      @change="changeBasicInfo"
    />

    <step06
      v-if="currentStep === 7"
      :data="application"
      :is-monthly-subscribe="isMonthlySubscribe"
      @next="addDriver"
    />
    <loading v-if="isLoading" />
  </div>
</template>

<script>
import { reduce, assign, isEmpty, get, has, toNumber, filter, round, sortBy, flatMap, map, toString, find } from 'lodash';
import ApiClient, { API } from 'api/client';
import Loading from 'components/Loading';
import StepIndicator from './main/StepIndicator';
import Step01 from './main/Step01';
import Step02 from './main/Step02';
import Step03 from './main/Step03';
import Step04 from './main/Step04';
import Step05 from './main/Step05';
import Step06 from './main/Step06';
import Agreement from './main/Agreement';
import DialogUtil from 'utils/dialog';
import HeaderUtil from 'utils/header';
import config from 'config';
import { isWebview } from 'utils/webview/isWebview';
import { postMessageToPlanHome } from 'utils/webview/postMessageToPlanHome';
import { closeWebView } from 'utils/webview/closeWebView';
import * as amplitude from '@amplitude/analytics-browser';

export default {
  name: 'Main',
  components: {
    StepIndicator,
    Step01,
    Step02,
    Step03,
    Step04,
    Step05,
    Step06,
    Agreement,
    Loading,
  },
  mixins: [ApiClient],
  props: {
    step: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      currentStep: toNumber(this.step),
      isLoading: false,
      options: {
        insurancePriceAgeTypes: [],
        insurancePriceTypes: [],
        purposes: [],
        funnels: [],
        repairingServices: [],
      },
      application: {
        applicationCustodyId: null,
        applicationId: null,
        contractId: null,
        hashingContractId: null,
        carClassName: null,
        carImage: null,
        regionName: null,
        rentEndDate: null,
        liValid: null,
        valid: null,
        // step01
        regionGroupId: null,
        regionGroup: null,
        rentRequestDate: null,
        rentMonths: null,
        carClassId: null,
        carClass: null,
        carClassFuel: null,
        carTypeId: null,
        carType: null,
        carGroup: null,
        carTypeName: null,
        repairingService: false,
        insurancePriceType: 'ISPTY_HALF_MILLION',
        priceId: null,
        insuranceType: null,
        insurancePrices: [],
        prepaidPaymentRateId: null,
        // insurancePriceId: null,
        // step02
        agreeTerms: {
          agreeService: false,
          agreeCarSharing: false,
          agreePrivacy: false,
          agreeThirdParty: false,
          agreeCreditCheck: false,
          agreeMonthlySubscribe: false,
        },

        // step agreement
        creditInquiryAgreementId: null,

        sendDim: false,
        verifyDim: true,
        showCountMessage: false,
        showCount: false,
        count: null,
        smsToken: null,
        confirmNum: null,
        verifiedToken: null,

        // step03
        warrantyType: null,
        creditRating: null,
        creditScore: null,
        warrantyTarget: null,
        creditResult: null,
        warranty: { // 보증보험 대상 여부 조회 결과.
          isTarget: true,
          percent: 0,
          deposit: 0,
        },

        // step04
        displayAddress: null,
        address: null,
        detailAddress: null,
        streetAddress: null,
        region1: null,
        region2: null,
        region3: null,
        location: null,
        postcode: null,
        // 탁송지역
        consignmentAddress: null,
        consignmentDetailAddress: null,
        consignmentPostcode: null,
        consignmentRegion1: null,
        consignmentRegion2: null,
        consignmentRegion3: null,
        consignmentLocation: null,
        // 인수 지역
        carConsignmentArea: 'SAME',
        method: 'CSNHD_SELF_PICKUP',
        takeOverTime: null,
        consignAt: null,
        takeOverLocationType: null, // 인수 지역 유형
        takeOverLocationTypeId: null,
        takeOverLocationDetail: null, // 특이사항
        funnel: null,
        funnelEtc: null,
        purpose: null,
        purposeEtc: null,
        // 친구추천 및 쿠폰코드
        referrerEmail: null,
        couponCode: null,

        // step05
        initialPayBillingId: null,
        legacyBillingId: null,
      },
      estimatedFee: {
        price: null,
        priceDiscount: null,
        insurancePrice: null,
      },
      estimatePrice: {},
      finalEstimatePrice: {},
      availableRegions: [],
      // 신용 조회 동의를 위해 들어온 사용자인치 판단
      creditInquiryAgreement: false,
      applicationId: null,
    };
  },
  computed: {
    indicatorStep() {
      const step = toNumber(this.step);
      return step === 3 ? step - 2 : step > 3 ? step - 3 : step - 1;
    },
    userName() {
      return this.$store.state.user.name;
    },
    isWarrantyTarget() {
      return get(this.application, 'warranty.isTarget', false);
    },
    isShortTerm() {
      if (this.application.carGroup !== null && this.application.rentMonths != null) {
        if (this.application.rentMonths < this.application.carGroup.creditCheckMonths) return true;
      }
      return false;
    },
    isMonthlySubscribe() {
      if (this.application.carGroup !== null && this.application.rentMonths === 1) {
        return true;
      }
      return false;
    },
    isPrepaidPayment() {
      return this.application.prepaidPaymentRateId !== null;
    },
    isAvanteN() {
      return this.application.carClassName === '더뉴아반떼N';
    },
  },
  watch: {
    '$route'() {
      this.currentStep = toNumber(this.step);
    },
  },
  async created() {
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        if (this.$route.path === '/application/main/7') {
          DialogUtil.alert('잘못된 접근입니다.\n플랜 홈으로 이동합니다.');
          if (isWebview()) {
            postMessageToPlanHome('/');
            closeWebView();
            return;
          }
          window.location.href = config.planHome.baseURL;
        }
      }
    });
    const hashingApplicationId = this.$route.query.applicationId;
    this.application.applicationCustodyId = hashingApplicationId;
    this.creditInquiryAgreement = this.$route.query.creditInquiryAgreement === 'true';
    if (this.$route.params.step !== '1' || isEmpty(hashingApplicationId)) {
      DialogUtil.alert('잘못된 접근입니다.\n플랜 홈으로 이동합니다.');
      if (isWebview()) {
        postMessageToPlanHome('/');
        closeWebView();
        return;
      }
      window.location.href = config.planHome.baseURL;
    } else {
      const authToken = HeaderUtil.isWebView() ? HeaderUtil.getCookie('auth_token') : HeaderUtil.getCookie('plan_auth_token');
      if (!this.$store.state.user.logged && authToken === null) {
        if (get(this.$route.query, 'force', 'false') !== 'true') {
          DialogUtil.alert('로그인이 필요합니다.');
          this.creditInquiryAgreement ? this.$router.replace({ path: `/login?redirect=/application/main?creditInquiryAgreement=true&applicationId=${hashingApplicationId}` }) : this.$router.replace({ path: `/login?redirect=/application/main?applicationId=${hashingApplicationId}` });
        } else {
          this.creditInquiryAgreement ? this.$router.replace({ path: `/login?redirect=/application/main?creditInquiryAgreement=true&applicationId=${hashingApplicationId}` }) : this.$router.replace({ path: `/login?redirect=/application/main?applicationId=${hashingApplicationId}` });
        }
      } else if (authToken !== null && (!this.$store.state.user.logged || this.$store.state.accessToken !== authToken)) {
      // 신용조회 동의를 위해 접근한 사용자일경우
      } else if (this.creditInquiryAgreement) {
        this.applicationId = hashingApplicationId;
        this.move(3);
      } else {
        this.isLoading = true;
        const CodeApi = this.getApi(API.CODE);
        const codes = await CodeApi.getCodes(['INSURANCE_PRICE_AGE_TYPE', 'INSURANCE_PRICE_TYPE', 'WARRANTY_TYPE', 'CAR_CONSIGNMENT_METHOD', 'TAKE_OVER_LOCATION_TYPE', 'CAR_GROUP_TYPE']);
        const applicationTags = await CodeApi.getApplicationTags();
        const funnel = filter(applicationTags, ({ category }) => (category === 'APPTC_FUNNEL'));
        const purpose = filter(applicationTags, ({ category }) => (category === 'APPTC_USE_PURPOSE'));
        const regionGroups = await CodeApi.getRegionGroups({ active: 1 });
        const userAllCards = await CodeApi.getBillings({ includeAll: true });
        const userRecurringCards = await CodeApi.getBillings();
        const CarTypeApi = this.getApi(API.CAR_TYPE);
        const CarGroupApi = this.getApi(API.CAR_GROUP);
        const ContractApi = this.getApi(API.CONTRACT);
        await ContractApi.getApplicationCustody({ applicationCustodyId: hashingApplicationId })
          .then(async ({ carClassId, carClassName, carClassFuel, carImage, carTypeId, carTypeName, liValid, priceId, regionGroupId, regionName, rentEndDate, rentMonths, rentRequestDate, valid, insurancePrices, insuranceType, prepaidPaymentRateId, prepaidRate }) => {
            this.application.regionGroupId = regionGroupId;
            this.application.regionGroup = find(regionGroups, (regionGroup) => (regionGroup.id === regionGroupId));
            this.application.rentRequestDate = rentRequestDate;
            this.application.rentMonths = rentMonths;
            this.application.carClassId = carClassId;
            this.application.carTypeId = carTypeId;
            this.application.carType = await CarTypeApi.getCarType(carTypeId);
            this.application.carGroup = await CarGroupApi.getCarGroup(this.application.carType.carGroupId);
            this.application.carTypeName = carTypeName;
            this.application.priceId = priceId;
            this.application.carClassName = carClassName;
            this.application.carClassFuel = carClassFuel;
            this.application.carImage = carImage;
            this.application.regionName = regionName;
            this.application.rentEndDate = rentEndDate;
            this.application.liValid = liValid;
            this.application.valid = valid;
            this.insuranceType = insuranceType;
            this.application.prepaidPaymentRateId = prepaidPaymentRateId === 0 ? null : prepaidPaymentRateId;
            this.application.prepaidRate = prepaidRate;
            if (insuranceType !== '') this.application.insurancePriceType = insuranceType;
            this.application.insurancePrices = insurancePrices;
            await this.calculateEstimate();
            codes.insurancePriceType.map((item) => {
              const insurancePrice = find(insurancePrices, (insurancePrice) => (insurancePrice.type === item.name));
              assign(item, { priceLabel: `${item.label} : ${this.formatNumber(insurancePrice.insuranceFee)} 원/월` });
            });
            this.options.insurancePriceAgeTypes = codes.insurancePriceAgeType;
            this.options.insurancePriceTypes = sortBy(codes.insurancePriceType, ['name']);
            this.options.carConsignmentMethods = codes.carConsignmentMethod.map((item) =>
              // 사용자에게 표시되는 문구 변경: 핸들예약 => 탁송
              (item.name === 'CSNHD_HANDLE_RESERVATION' ? assign(item, { label: '배송' }) : item)
            );
            this.options.warrantyTypes = codes.warrantyType;
            this.options.takeOverLocationTypes = codes.takeOverLocationType;
            // 정비 서비스
            this.options.repairingServices = [{ label: '기본형', value: false }, { label: '고급형', value: true }];
            // 사용자 전체 카드 목록
            this.options.userAllCards = userAllCards;
            // 사용자 정기카드 결제 가능 카드 목록
            this.options.userRecurringCards = userRecurringCards;
            this.options.funnels = funnel;
            this.options.purposes = purpose;
            this.isLoading = false;
            if (!liValid) {
              DialogUtil.alert('해당 차종은 1종 면허만 신청이 가능합니다.\n다른 차량을 찾아 계약을 신청해주세요.');
              if (isWebview()) {
                closeWebView();
                return;
              }
              window.location.href = config.planHome.baseURL;
            } else if (!valid) {
              DialogUtil.alert('해당 차량은 만 26세 미만일 경우 계약이 불가합니다.\n다른 차량을 찾아 계약을 신청해주세요.');
              if (isWebview()) {
                closeWebView();
                return;
              }
              window.location.href = config.planHome.baseURL;
            }
            this.moveNotHistory(2);
          })
          .catch(() => {
            if (isWebview()) {
              closeWebView();
              return;
            }
            window.location.href = config.planHome.baseURL;
          });
      }
    }
  },
  methods: {
    async back(step) {
      await this.$router.back();
    },
    async move(step) {
      this.currentStep = step;
      await this.$router.push({ path: `/application/main/${step}` });
    },
    async moveNotHistory(step) {
      this.currentStep = step;
      await this.$router.replace({ path: `/application/main/${step}` });
    },
    save(data) {
      this.application = assign({}, this.application, data);
    },
    async beforeMove(step, data) {
      let nextStep = step;
      this.application = assign({}, this.application, data);
      switch (step) {
        case 3:
          if (this.isShortTerm) {
            nextStep = 4;
            await this.checkWarranty();
            if (!this.application.warranty.isTarget) {
              nextStep = 5;
              await this.getAvailableRegionAndTime();
            } else if (isEmpty(this.application.warrantyTarget)) {
              DialogUtil.alert('입력해주신 정보가 신용 평가 회사(NICE 평가정보(주))에서 조회되지 않아 계약 진행이 어렵습니다.\n불편을 드려 죄송합니다.\n* 쏘카플랜 1개월 계약 시에는 신용 조회가 진행되지 않습니다. 대여 기간 한달 계약을 원하실 경우, 재 신청해주시기 바랍니다.');
              if (isWebview()) {
                closeWebView();
                return;
              }
              window.location.href = config.planHome.baseURL;
              return;
            } else if (this.application.warrantyTarget === '계약불가') {
              DialogUtil.alert('신용점수가 내부 조건에 부합하지 않아 계약을 진행할 수 없습니다.\n다른 상품으로 계약을 진행해 주세요.');

              const args = {
                page_name: 'plan_car_contract',
                event_category: document.title,
                page_url: document.URL,
                component_name: 'plan_no_credit_alert',
              };

              this.$gtag.event('click', args);
              amplitude.logEvent('click', args);

              if (isWebview()) {
                closeWebView();
                return;
              }
              window.location.href = config.planHome.baseURL;
              return;
            }
          }
          break;
        case 4:
          await this.checkWarranty();
          if (!this.application.warranty.isTarget) {
            nextStep = 5;
            await this.getAvailableRegionAndTime();
          } else if (isEmpty(this.application.warrantyTarget)) {
            // DialogUtil.confirm('신용조회에 실패하였습니다.\n세이프키 발급을 통해 신용 조회 완료 후, 계약이 진행됩니다.\n세이프키 발급 안내를 도와드릴까요?\n확인을 누르시면 안내 SMS가 발송됩니다.', async() => {
            //   await this.createApplication();
            //   window.location.href = 'https://plan.socar.kr/';
            // });
            DialogUtil.alert('입력해주신 정보가 신용 평가 회사(NICE 평가정보(주))에서 조회되지 않아 계약 진행이 어렵습니다.\n불편을 드려 죄송합니다.\n* 쏘카플랜 1개월 계약 시에는 신용 조회가 진행되지 않습니다. 대여 기간 한달 계약을 원하실 경우, 재 신청해주시기 바랍니다.');
            return;
          } else if (this.application.warrantyTarget === '계약불가') {
            DialogUtil.alert('신용점수가 내부 조건에 부합하지 않아 계약을 진행할 수 없습니다.');

            const args = {
              page_name: 'plan_car_contract',
              event_category: document.title,
              page_url: document.URL,
              component_name: 'plan_no_credit_alert',
            };

            this.$gtag.event('click', args);
            amplitude.logEvent('click', args);

            return;
          }
          break;
        case 5:
          await this.getAvailableRegionAndTime();
          break;
        case 6:
          await this.calculateFinalEstimate();
          break;
        case 7: {
          const result = await DialogUtil.confirm('결제 정보를 확인하셨나요?\n[확인] 선택 시, 결제 및 쏘카플랜 계약이 진행됩니다.', async() => {
            await this.submit();
            return true;
          });
          if (result !== true) return;
        }
          break;
        default:
          // skip
      }
      await this.move(nextStep);
    },
    async changeBasicInfo(application) {
      const diff = reduce(this.application, (result, value, key) => {
        if (value !== application[key]) {
          result[key] = application[key];
        }
        return result;
      }, {});
      this.application = assign({}, application);
      if (has(diff, 'repairingService') || has(diff, 'insurancePriceType')) {
        await this.calculateEstimate()
          .catch(() => {
            this.$router.replace('/');
          });
      }
    },
    async calculateEstimate() {
      if (this.application.priceId != null && this.application.rentMonths != null && !isEmpty(this.application.insurancePriceType) && this.application.repairingService != null) {
        const PriceApi = this.getApi(API.PRICE);
        const price = await PriceApi.getEstimatedMonthlyPrice({
          priceId: this.application.priceId,
          rentMonths: this.application.rentMonths,
          insurancePriceType: this.application.insurancePriceType,
          repairingService: this.application.repairingService,
        });
        this.estimatePrice = {
          totalMonthlyRentFee: price.totalMonthlyRentFee,
          monthlyRentFee: price.monthlyRentFee,
          monthlyRepairingFee: price.monthlyRepairingFee,
          insuranceFee: price.insuranceFee,
          discount: price.discountFee,
          overrunFee: price.overrunFee,
          promotionDiscountFee: price.promotionDiscountFee,
          discountRate: round((price.discountFee / price.monthlyRentFee) * 100, 2),
        };
      } else {
        this.estimatePrice = {};
      }
    },
    async calculateFinalEstimate() {
      if (!isEmpty(this.application.method) && !isEmpty(this.application.address)) {
        const PriceApi = this.getApi(API.PRICE);
        const price = await PriceApi.getEstimatedMonthlyPrice({
          priceId: this.application.priceId,
          rentMonths: this.application.rentMonths,
          insurancePriceType: this.application.insurancePriceType,
          repairingService: this.application.repairingService,
          consignmentAddress: this.application.consignmentAddress,
          consignmentAddressRegion1: this.application.consignmentRegion1,
          consignmentAddressRegion2: this.application.consignmentRegion2,
          method: this.application.method,
          prepaidPaymentRateId: this.application.prepaidPaymentRateId,
        });
        this.finalEstimatePrice = {
          totalRentFee: price.totalRentFee,
          totalMonthlyRentFee: price.totalMonthlyRentFee,
          monthlyRentFee: price.monthlyRentFee,
          monthlyRepairingFee: price.monthlyRepairingFee,
          insuranceFee: price.insuranceFee,
          discount: price.discountFee,
          overrunFee: price.overrunFee,
          discountRate: round((price.discountFee / price.monthlyRentFee) * 100, 2),
          consignmentFee: price.consignmentFee,
          promotionDiscountFee: price.promotionDiscountFee,
          prepaidRate: price.prepaidRate,
          prepaidPaymentTotalFee: price.prepaidPaymentTotalFee,
          prepaidPaymentDeductionFee: price.prepaidPaymentDeductionFee,
          prepaidPaymentDiscountFee: price.prepaidPaymentDiscountFee,
          totalFirstMonthRentFee: price.totalFirstMonthRentFee,
        };
      } else {
        this.finalEstimatePrice = {};
      }
    },
    async getAvailableRegionAndTime() {
      const RegionGroupApi = this.getApi(API.REGION_GROUP);
      const regions = await RegionGroupApi.getRegionGroup(this.application.regionGroupId);
      this.availableRegions = flatMap(regions.regions, 'region2');
      const availableTimes = map(regions.availableTimes, (time) => {
        const regionAvailableTime = toString(time.regionAvailableTime).length === 1 ? `0${time.regionAvailableTime}:00` : `${time.regionAvailableTime}:00`;
        return { id: time.regionAvailableTime, label: regionAvailableTime };
      });
      if (availableTimes.length > 0) this.options.availableTimes = availableTimes;
    },
    async changeAddress(data) {
      this.application.address = data.address;
      this.application.streetAddress = data.streetAddress;
      this.application.region1 = data.region1;
      this.application.region2 = data.region2;
      this.application.region3 = data.region3;
      this.application.location = data.location;
      this.application.postcode = data.postcode;
      await this.calculateFinalEstimate();
    },
    async checkWarranty() {
      this.isLoading = true;
      if (this.isShortTerm) {
        this.application.warrantyTarget = 'WRTTG_NON_TARGET';
        this.application.warrantyType = null;
        this.application.creditRating = '0';
        this.application.creditScore = '0';
        this.application.warranty.isTarget = false;
        this.application.warranty.percent = 0;
        this.application.warranty.deposit = 0;
        this.isLoading = false;
        return;
      }
      const CreditRatingApi = this.getApi(API.CREDIT_RATING);
      const CarTypeApi = this.getApi(API.CAR_TYPE);
      const { credit } = await CreditRatingApi.getCreditRating({
        rentMonths: this.application.rentMonths,
        carTypeId: this.application.carType.id,
        carGroupId: this.application.carType.carGroupId,
        prepaidPaymentRateId: this.application.prepaidPaymentRateId,
      });
      this.application.creditRating = credit.creditRating;
      this.application.creditScore = credit.creditScore;
      this.application.warrantyTarget = credit.warrantyTarget;
      this.application.creditResult = credit.creditResult;
      switch (credit.warrantyTarget) {
        case 'WRTTG_NON_TARGET':
          this.application.warranty.isTarget = false;
          this.application.warranty.percent = 0;
          this.application.warranty.deposit = 0;
          break;
        case 'WRTTG_PCT_10_TARGET': {
          this.application.warranty.isTarget = true;
          this.application.warranty.percent = 10;
          const { deposit } = await CarTypeApi.getDeposit({ carTypeId: this.application.carTypeId, warrantyTarget: credit.warrantyTarget });
          this.application.warranty.deposit = deposit.depositFee;
        }
          break;
        case 'WRTTG_PCT_20_TARGET': {
          this.application.warranty.isTarget = true;
          this.application.warranty.percent = 20;
          const { deposit } = await CarTypeApi.getDeposit({ carTypeId: this.application.carTypeId, warrantyTarget: credit.warrantyTarget });
          this.application.warranty.deposit = deposit.depositFee;
        }
          break;
        default:
          this.application.warranty.isTarget = true;
          this.application.warranty.percent = 0;
          this.application.warranty.deposit = 0;
          break;
      }
      this.isLoading = false;
    },
    async submit() {
      const ContractApi = this.getApi(API.CONTRACT);
      // TODO: 쏘카페이 계좌 pin번호 확인처리
      // const initialBilling = find(this.options.userAllCards, (item) => (item.id === this.application.initialBillingId));
      // if (initialBilling.paymentMethodType === 'SOCAR_PAY_ACCOUNT') {
      //   const data = await ContractApi.getSocarPayFinUrl({
      //     legacyBillingId: initialBilling.id,
      //     priceId: this.application.priceId,
      //     prepaidPaymentRateId: this.application.prepaidPaymentRateId,
      //     rentMonths: this.application.rentMonths,
      //     consignmentAddressRegion1: this.application.consignmentRegion1,
      //     consignmentAddressRegion2: this.application.consignmentRegion2,
      //     insurancePriceType: this.application.insurancePriceType,
      //     method: this.application.method,
      //     repairingService: this.application.repairingService,
      //   });
      const params = assign({}, this.application, {
        consignmentAddressRegion1: this.application.consignmentRegion1,
        consignmentAddressRegion2: this.application.consignmentRegion2,
      });
      this.isLoading = true;
      const data = await ContractApi.createApplicationAndContract(params);
      this.isLoading = false;
      if (!isEmpty(data)) {
        this.application.id = data.applicationId;
        this.application.contractId = data.contractId;
        this.application.hashingContractId = data.hashingContractId;
      }
      return data;
    },
    async createApplication() {
      const params = assign({}, this.application);
      const ApplicationApi = this.getApi(API.APPLICATION);
      this.isLoading = true;
      const data = await ApplicationApi.createApplication(params);
      this.isLoading = false;
      return data;
    },
    addDriver() {
      const hashingContractId = this.application.hashingContractId;
      this.$router.push(`/application/additional/1?contractId=${hashingContractId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.divider-margin {
  margin: 50px 0 50px 0;
}
.bottom-button {
  padding: 5px 5px 5px 5px;
}
</style>
